import './Contact.css';
import './scrollAnimations.css';
import { useEffect, useState } from 'react';
import useScrollAnimation from './useScrollAnimation';

function Contact({ onNavigateHome }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useScrollAnimation();

  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Normally you'd send this to an API or email service like EmailJS
    alert("Message sent successfully! (This is a demo)");
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <div className="contact-page">
      {/* ── Header ── */}
      <header className="contact-header">
        <div className="contact-header-inner">
          <button className="contact-back-btn" onClick={onNavigateHome}>
            <span className="contact-back-arrow">&#8592;</span> Back to Portfolio
          </button>
          <nav className="contact-breadcrumb">
            <span className="contact-bc-home" onClick={onNavigateHome}>Home</span>
            <span className="contact-bc-sep">/</span>
            <span className="contact-bc-current">Contact</span>
          </nav>
        </div>
      </header>

      {/* ── Hero Strip ── */}
      <div className="contact-hero-strip">
        <div className="contact-strip-inner">
          <p className="contact-strip-label scroll-animate-hero" data-delay="0">Get In Touch</p>
          <h1 className="contact-strip-name scroll-animate-hero" data-delay="100">Contact Me</h1>
          <p className="contact-strip-role scroll-animate-hero" data-delay="200">Let's connect and discuss opportunities.</p>
        </div>
      </div>

      {/* ── Main Content ── */}
      <main className="contact-main">
        <div className="contact-grid">
          
          <div className="contact-info scroll-animate" data-delay="0">
            <div>
              <h2 className="contact-title">Let's work together.</h2>
              <p className="contact-desc">
                I'm currently open to new opportunities, collaborations, and projects. Whether you have a question or just want to say hi, I'll try my best to get back to you!
              </p>
            </div>

            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon">&#9993;</div>
                <div className="contact-text">
                  <span className="contact-label">Email</span>
                  <a href="mailto:christiankalaw@gmail.com" className="contact-val">christiankalaw@gmail.com</a>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">&#128222;</div>
                <div className="contact-text">
                  <span className="contact-label">Phone</span>
                  <span className="contact-val">+63 912 345 6789</span>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">&#128205;</div>
                <div className="contact-text">
                  <span className="contact-label">Location</span>
                  <span className="contact-val">Lipa City, Batangas</span>
                </div>
              </div>
            </div>

            <div className="contact-socials">
              <a href="https://github.com/christiankalaw" target="_blank" rel="noreferrer" className="contact-social-btn">
                GitHub <span>&#8599;</span>
              </a>
              <a href="https://linkedin.com/in/christiankalaw" target="_blank" rel="noreferrer" className="contact-social-btn">
                LinkedIn <span>&#8599;</span>
              </a>
            </div>
          </div>

          <div className="contact-form-card scroll-animate" data-delay="150">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Your Name</label>
                <input 
                  type="text" 
                  name="name" 
                  value={formData.name} 
                  onChange={handleChange} 
                  className="form-input" 
                  placeholder="John Doe" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Email Address</label>
                <input 
                  type="email" 
                  name="email" 
                  value={formData.email} 
                  onChange={handleChange} 
                  className="form-input" 
                  placeholder="john@example.com" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea 
                  name="message" 
                  value={formData.message} 
                  onChange={handleChange} 
                  className="form-textarea" 
                  placeholder="Hello, I'd like to talk about..." 
                  required 
                />
              </div>
              <button type="submit" className="form-submit">Send Message</button>
            </form>
          </div>

        </div>
      </main>

      {/* ── Footer ── */}
      <footer className="contact-footer scroll-animate">
        <p>Christian D. Kalaw &copy; {new Date().getFullYear()}</p>
        <button className="contact-footer-back" onClick={onNavigateHome}>Back to Portfolio</button>
      </footer>
    </div>
  );
}

export default Contact;
